/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{05DF4B0A-5DCF-446C-9DF4-239D49CC265F}",
  "sitecoreApiHost": "http://localhost:3000",
  "jssAppName": "vad",
  "defaultLanguage": "en",
  "apiHost": "https://locahost",
  "widgetUrl": "/where-to-go",
  "flightSearch": "http://flights.vadsc.in/{0}/flights/search/",
  "hotelSearch": "https://hotels.vadsc.in/?a_aid=44509&brandid=560850",
  "appInsightsInstrumentationKey": "3aa11bab-7f74-4f5f-b673-97b59fe3ce0a",
  "GEO_JSON_API": "undefined/v1/explore-map/geojson",
  "LIVE_WEATHER_API": "undefined/weather/v1/current",
  "EVENT_API": "undefined/search/v1",
  "AUTO_COMPLETE_WEGO": "undefined/wego",
  "AUTO_COMPLETE_TRAVEL_PAYOUT": "undefined/travelpayouts/places2",
  "SOLR_FILTERS_DATA": "undefined/search/v1",
  "SOLR_SEARCH_API": "undefined/search/v1/global",
  "SOLR_FAVORITE_SEARCH_API": "undefined/search/v1/favorite",
  "SMART_LIST_API": "undefined/search/v1",
  "RFP_API": "undefined/rfp/v1",
  "RFP_API_VIRUS_CHECK": "undefined/storage/v1/scan",
  "COMPETITION_FORM_API": "undefined/competition/v1/",
  "FORM_SUBMISSION_API": "undefined/feedback/v1",
  "NEWSLETTER_SUBSCRIPTION_API": "undefined/newsletter/v1/subscribe/vad",
  "SIMILAR_SEARCH_API": "undefined/search/v1/similar",
  "TRIP_ADVISOR_API": "undefined/trip-advisor/{location}?lang={language}",
  "GOOGLE_PLACES_API": "undefined/operating-hours/v1/{placeId}",
  "TINT_API": "undefined/tint/",
  "ADVANCE_SEARCH_API": "undefined/search/v1/suggest?q={searchTerm}&lang={language}&limit={limit}",
  "PRELOAD_LINK_MEGAMENU_IMAGE": "true",
  "NO_RETINA_MEGANAV": "true",
  "ADD_TO_CALENDER_API": "undefined/api/event/v1/{0}/add-to-calendar",
  "MAIL_CHIMP_FORM_GET_QUESTIONS_API": "undefined/api/v1/dynamics/questions",
  "MAIL_CHIMP_FORM_SUBMIT_API": "undefined/api/v1/dynamics/submit",
  "GOOGLE_ADD_TO_CALENDER_URL": "https://calendar.google.com/calendar/render?action=TEMPLATE&dates={startDate}/{endDate}&location={location}&text={title}&details={description}",
  "MAP_ACCESS_TOKEN": "pk.eyJ1IjoiZGN0YWJ1ZGhhYmkiLCJhIjoiY2w2YzM4cnAxMDB0dzNtcWlvdTkwaTgwMCJ9.6HW8jE5migwN6rdj-H_9TA",
  "MAP_BOX_STYLE": "mapbox://styles/dctabudhabi/cl4faibzi002x14oc10prtrwl",
  "EVENTS_GRID_LISTING_API": "undefined/v1/grid-listing",
  "NEWSLETTER_SUBSCRIPTION_API_V2": "undefined/api/v2/subscribe-newsletter",
  "FETCH_COUNTRIES_API": "undefined/api/v1/countries"
};